import { useDispatch } from "react-redux";
import Xarrow from "react-xarrows";
import { importFromYaml } from "../../../../abstract/controller/modelYamlImport";
import { useArrowSync } from "../../../../abstract/hook/useArrowSync";
import { setRoot } from "../../../../abstract/redux/slice/structureSlice";
import ButtonIntroWide from "../../../ui/buttons/ButtonIntroWide";
import ButtonTomatoClose from "../../../ui/buttons/ButtonTomatoClose";
import styles from "./Manual.module.scss";
import IconWindowMaximize2 from "../../../../themes/icons/IconWindowMaximize2";

const showMe = `
global parameters:
  - parameter: weapon
    choices:
      - choice: sword
        value: Excalibur
      - choice: dagger
      - choice: axe
      - choice: mace
      - choice: ranged
        choices:
          - choice: bow
          - choice: crossbow
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - linked parameter: hero weapon
        linked to: weapon
      - parameter: foe
        choices:
          - choice: witch
          - choice: cyclops
          - choice: giant
      - linked parameter: foe weapon
        linked to: weapon
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
          - choice: mountain
          - choice: lake

`;

const goBack = `
global parameters:
  - parameter: weapon
    choices:
      - choice: sword
      - choice: dagger
      - choice: axe
      - choice: mace
      - choice: bow
      - choice: crossbow
functions:
  - function: simple
    parameters:
      - parameter: hero
        choices:
          - choice: Peter
          - choice: Susan
          - choice: Edmund
          - choice: Lucy
      - linked parameter: hero weapon
        linked to: weapon
      - parameter: foe
        choices:
          - choice: witch
          - choice: cyclops
          - choice: giant
      - linked parameter: foe weapon
        linked to: weapon
      - parameter: location
        choices:
          - choice: forest
          - choice: castle
          - choice: river
          - choice: mountain
          - choice: lake
`;

function ManualHierarchyAndValues2({ setTutorial }) {
  const _dispatch = useDispatch();
  const renderTrigger = useArrowSync();

  const handleShowMe = () => {
    const { model } = importFromYaml(showMe);
    _dispatch(setRoot(model, 0));
  };

  const handleBack = () => {
    const { model } = importFromYaml(goBack);
    _dispatch(setRoot(model, 0));
    setTutorial("hav1");
  };

  const handleClose = () => {
    setTutorial("null");
  };

  return (
    <>
      {document.getElementById("header_globals") &&
        !document.getElementById("add_global_parameter") && (
          <div className={`${styles["container"]} ${styles["container-hv2"]} ${styles["overlay"]}`}>
            <div id="tutorial-text-hv1" className={`${styles["container__text"]}`}>
              <p>To show/hide global parameters click on the header.</p>
            </div>

            <Xarrow
              key={`arrow-1-${renderTrigger}`}
              start="tutorial-text-hv1"
              end="header_globals"
              color="#415B32"
              strokeWidth={2}
              path="smooth"
              curveness={0.8}
              headSize={6}
            />
          </div>
        )}

      <div className={`${styles["foreground"]} ${styles["foreground-hv2"]}  ${styles["overlay"]}`}>
        <ButtonTomatoClose onClick={handleClose} />
        <div className={styles["header"]}>
          <div className={styles["header__assistant"]}></div>
          <div className={styles["header__text--main"]}>
            <p>
              Every leaf choice has its own value, which is used during the generation process. When
              the value field is empty, the value defaults to the choice name. Remember that choice
              names have some limitations - for example, it’s not possible to have multiple choices
              with the same name. With values, however, this limitation doesn’t exist. Since
              abstract choices act as containers and aren’t directly used in the generation process,
              it’s not possible to assign values to them.
            </p>
            <p>
              Now, let's assign a value to the <b>sword</b> choice. To see the meta panel, hover
              over it and click on the <IconWindowMaximize2 /> icon. As the <b>value</b>, type{" "}
              <b>Excalibur</b>. Afterwards, you can hide the meta window.
            </p>
          </div>
        </div>
        <div className={styles["confirmation"]}>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="red" title="Go back!" onClick={handleBack} />
          </div>
          <div className={styles["button"]}>
            <ButtonIntroWide theme="tomato" title="Show me!" onClick={handleShowMe} />
          </div>
        </div>
      </div>
    </>
  );
}

export default ManualHierarchyAndValues2;
